/**
 * Tiny in-page bus so the incident triage panel can hand a saved query to the
 * error drilldown panel (they are siblings inside Runtime health).
 */

export type DrilldownFilters = {
  q?: string;
  route?: string;
  session?: string;
  fingerprint?: string;
  release?: string;
  from?: string;
  to?: string;
};

const EVENT = "runtime-health:apply-drilldown";
export const DRILLDOWN_ANCHOR_ID = "runtime-health-drilldown";

export function applyDrilldownFilters(filters: DrilldownFilters): void {
  window.dispatchEvent(new CustomEvent<DrilldownFilters>(EVENT, { detail: filters }));
  document.getElementById(DRILLDOWN_ANCHOR_ID)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function onApplyDrilldownFilters(handler: (filters: DrilldownFilters) => void): () => void {
  const listener = (event: Event) => handler((event as CustomEvent<DrilldownFilters>).detail ?? {});
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
